<!-- 我的商品 -->
<template>
  <div class="component-page">
    <div class="goods-tabs">
      <div class="tabs-left">
        <!-- <strong>商品分类</strong> -->
        <ul>
          <li
            v-for="tabItem in goodsCategory.list"
            :key="tabItem.value"
            :class="{
              tabItem: 1,
              active: tabItem.value === goodsCategory.value,
            }"
            @click="methodChangeGoodsCate(tabItem.value)"
          >
            {{ tabItem.label }}
          </li>
        </ul>
      </div>
    </div>
    <el-row :gutter="10" v-if="tableData.join('') !== ''">
      <el-col :span="5" v-for="item in tableData" :key="item.id">
        <div
          :class="{
            'col-div': true,
            // 'not-border-right': (index + 1) % 4 !== 0,
            // 'not-border-bottom': index < 12 - 4,
          }"
        >
          <div class="goods-img">
            <img :src="item.highPictureUrl" alt="" />
          </div>
          <div class="goods-info">
            <div class="name">
              {{ item.productName }}
            </div>
            <div class="category">
              <span>
                {{ categoryMap[item.productCategory] }}
              </span>
              <span v-if="item.productCategory === 2"
                >数量：{{ item.exchangeNum }}</span
              >
            </div>
            <div class="btns">
              <button
                :class="{
                  btn: 1,
                  received: item.state < 1,
                  wear: item.state === 2,
                }"
                @click="stuOrderUpdateWearState(item)"
              >
                {{ stateMap[item.state] }}
              </button>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-empty v-else description="暂无数据"></el-empty>
  </div>
</template>
<script>
// 引入请求
import {
  api_stuOrderSelectListByStu,
  api_stuOrderUpdateWearState,
} from '@/api/javaApi'

export default {
  name: 'myGoods',
  props: ['pageInfo'],
  data() {
    return {
      goodsCategory: {
        value: null,
        list: [
          { label: '全部', value: null },
          { label: '头像', value: 3 },
          { label: '挂件', value: 1 },
          { label: '伴学精灵', value: 0 },
          { label: '实物商品', value: 2 },
        ],
      },
      tableData: [],
      categoryMap: {
        null: '全部',
        0: '伴学精灵',
        1: '头像挂件',
        2: '实物',
        3: '头像',
      },
      stateMap: {
        0: '未领取',
        1: '已领取',
        2: '佩戴',
        3: '佩戴中',
      },
    }
  },
  computed: {
    calcPageInfo() {
      return window.JSON.stringify(this.pageInfo)
    },
    headImageUrl() {
      return this.$store.state.user.userInfo.headimgUrl
    },
  },
  watch: {
    // 直接监听prop新旧值一样，因为是引用类型，所以用计算属性包裹一下变成字符串
    calcPageInfo: {
      handler(newPage, oldPage) {
        if (oldPage !== newPage && window.JSON.parse(newPage).update) {
          this.stuOrderSelectListByStu()
        }
      },
    },
    headImageUrl: {
      handler() {
        // 判断如果学生从右上角更改了头像，重新获取列表
        this.stuOrderSelectListByStu()
      },
    },
  },
  created() {
    this.stuOrderSelectListByStu()
  },
  methods: {
    methodChangeGoodsCate(active) {
      this.goodsCategory.value = active
      this.stuOrderSelectListByStu()
    },
    stuOrderSelectListByStu() {
      api_stuOrderSelectListByStu({
        stuId: this.$store.state.user.userInfo.id,
        category: this.goodsCategory.value,
        pageRequest: {
          pageNum: this.pageInfo.currentPage,
          pageSize: this.pageInfo.pageSize,
        },
      }).then((res) => {
        res.content.forEach((item) => {
          item.highPictureUrl =
            this.$store.state.resource.picBaseUrl + item.highPictureUrl
        })
        this.tableData = res.content
        this.$emit('returnPage', {
          currentPage: res.pageNum,
          pageSize: res.pageSize,
          total: res.totalSize,
          update: false,
        })
      })
    },
    stuOrderUpdateWearState(item) {
      // state 商品状态（0未领取，1已领取，2未佩戴，3已佩戴）
      // 0 1 return出去
      console.log('item:', item)
      if (item.state === 0 || item.state === 1) return false
      const routeState = item.state === 2 ? 1 : 0
      api_stuOrderUpdateWearState({
        id: item.id,
        stuId: this.$store.state.user.userInfo.id,
        productCategory: item.productCategory,
        userName: this.$store.state.user.userInfo.stuUserInfo.realName,
        route: routeState,
      }).then(async (res) => {
        console.log(res)
        await this.$store.dispatch('getStuTitleUrl')
        if (item.productCategory === 3) {
          this.$store.dispatch('freshUserData')
        }
        this.$message.success(routeState === 0 ? '已摘下！' : '佩戴成功！')
        this.stuOrderSelectListByStu()
      })
    },
  },
}
</script>
<style scoped lang="scss">
.component-page {
  min-height: 700px;
  .goods-tabs {
    display: flex;
    justify-content: space-between;
    align-items: center;

    margin-bottom: 10px;
    padding: 0 40px;
    background: #ffffff;
    border-radius: 10px;
    font-size: 14px;
    .tabs-left {
      display: flex;
      align-items: center;
      strong {
        margin-right: 60px;
      }
      ul {
        display: flex;
        align-items: center;
        li.tabItem {
          position: relative;
          display: inline-flex;
          align-items: center;
          height: 45px;
          margin-right: 60px;
          transition: all 0.25s;
          cursor: pointer;
          &::after {
            content: '';
            position: absolute;
            bottom: -1px;
            left: 50%;
            transform: translateX(-50%);
            width: 0px;
            height: 3px;
            background: #1678ff;
            border-radius: 3px;
            transition: width 0.15s;
          }
          &:hover {
            color: #1578ff;
          }
          &.active {
            color: #1578ff;
            font-weight: bold;
            &::after {
              width: 35px;
            }
          }
        }
      }
    }
    .tabs-right {
      display: flex;
      align-items: center;
      strong {
        margin-right: 30px;
      }
      .btn-content {
        position: relative;
        display: inline-flex;
        align-items: center;
        padding-left: 30px;
        font-size: 14px;
        img {
          position: absolute;
          &.hot {
            left: 5px;
            width: 15px;
            margin-right: 10px;
          }
          &.new {
            left: 0;
            width: 25px;
            margin-right: 8px;
          }
        }
      }
    }
  }
  .el-row {
    display: flex;
    flex-wrap: wrap;
    .el-col {
      position: relative;
      z-index: 1;
      perspective: 1000px;
      transform-style: preserve-3d;
      width: 20%;
      &:hover {
        z-index: 2;
      }
      .col-div {
        position: relative;
        margin-bottom: 10px;
        background-color: #fff;
        // border-radius: 10px;
        transition: all 0.2s;
        border: 1px solid #e6e6e6;
        border-radius: 10px;
        &.not-border-right {
          border-right-color: transparent;
        }
        &.not-border-bottom {
          border-bottom-color: transparent;
        }
        &:hover {
          box-shadow: 0px 0px 10px 0px #e6e6e6;
          transform: translate3d(0, 0, 20px);
          &.not-border-right {
            border-right-color: #e6e6e6;
          }
          &.not-border-bottom {
            border-bottom-color: #e6e6e6;
          }
        }
        .goods-img {
          box-sizing: border-box;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 220px;
          padding: 10px;
          img {
            display: block;
            width: 100%;
            height: 100%;
            max-height: 100%;
            object-fit: cover;
          }
        }
        .goods-info {
          padding: 0px 25px 15px;
          .name {
            // height: 21px;
            padding-bottom: 5px;
            font-weight: 400;
            font-size: 14px;
            color: #0a1629;
          }
          .category {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 5px;
            font-weight: 400;
            font-size: 12px;
            color: #666666;
          }
          .btns {
            display: flex;
            justify-content: flex-end;
            .btn {
              outline: none;
              border: none;
              display: inline-flex;
              justify-content: center;
              align-items: center;
              height: 30px;
              padding: 0 14px;
              font-weight: 400;
              font-size: 14px;
              color: #1678ff;
              background-color: #fff;
              border: 1px solid #1678ff;
              border-radius: 50px;
              transition: all 0.25s;
              cursor: pointer;
              &.received {
                border-color: #d4d4d4;
                background-color: #d4d4d4;
                color: #ffffff;
                cursor: initial;
              }
              &.wear {
                color: #fff;
                background-color: #1678ff;
              }
            }
          }
        }
      }
    }
  }
}
</style>
